import UiChevron from '@/components/ui/ui-chevron.vue';
import UiButton from '@/components/ui/ui-button.vue';
import UiMenu from '@/components/ui/ui-menu/index.vue';
import UiMenuContent from '@/components/ui/ui-menu/content.vue';
import UiSelect from '@/components/ui/ui-select/index.vue';
import UiSelectLanguage from '@/components/ui/ui-select-language.vue';
import UiSelectItem from '@/components/ui/ui-select/item.vue';
import UiInput from '@/components/ui/ui-input.vue';
import UiLabel from '@/components/ui/ui-label.vue';
import UiTooltipIcon from '@/components/ui/ui-tooltip-icon.vue';
import UiButtonMulti from '@/components/ui/ui-button-multi.vue';
import UiDatePicker from '@/components/ui/ui-date-picker.vue';
import UiInputTime from '@/components/ui/ui-input-time.vue';
import UiChip from '@/components/ui/ui-chip.vue';
import UiMenuContentItem from '@/components/ui/ui-menu/content-item.vue';
import UiPeriodPicker from '@/components/ui/ui-period-picker.vue';
import UiInputDetails from '@/components/ui/ui-input-details.vue';
import UiPeriodPickerInput from '@/components/ui/ui-period-picker-input.vue';
import UiDateTimePicker from '@/components/ui/ui-date-time-picker.vue';
import UiInfo from '@/components/ui/ui-info.vue';
import UiCheckbox from '@/components/ui/ui-checkbox.vue';
import UiRadio from '@/components/ui/ui-radio.vue';
import UiRadioGroup from '@/components/ui/ui-radio-group.vue';
import UiSwitcher from '@/components/ui/ui-switcher.vue';
import UiTextarea from '@/components/ui/ui-textarea.vue';
import UiTabs from '@/components/ui/ui-tabs.vue';
import UiIcon from '@/components/ui/ui-icon.vue';
import UiTreeview from '@/components/ui/ui-treeview.vue';
import UiPlanLimits from '@/components/ui/ui-plan-limits.vue';
import UiUpdateInfo from './ui-update-info.vue';
import UiCopyInput from './ui-copy-input.vue';
import UiCopyTextarea from './ui-copy-textarea.vue';
import UiCountInput from './ui-count-input.vue';
import UiCreateUrlTags from './ui-create-url-tags.vue';
import UiNotFound from './ui-not-found.vue';
import UiTable from './ui-table/table.vue';
import  UiPhoneInput from './ui-phone-input.vue';


export class UIService {
  install(app: any) {
    app.component('ui-chevron', UiChevron);
    app.component('ui-button', UiButton);
    app.component('ui-menu', UiMenu);
    app.component('ui-menu-content', UiMenuContent);
    app.component('ui-select', UiSelect);
    app.component('ui-select-language', UiSelectLanguage);
    app.component('ui-select-item', UiSelectItem);
    app.component('ui-input', UiInput);
    app.component('ui-label', UiLabel);
    app.component('ui-tooltip-icon', UiTooltipIcon);
    app.component('ui-button-multi', UiButtonMulti);
    app.component('ui-date-picker', UiDatePicker);
    app.component('ui-input-time', UiInputTime);
    app.component('ui-chip', UiChip);
    app.component('ui-menu-content-item', UiMenuContentItem);
    app.component('ui-period-picker', UiPeriodPicker);
    app.component('ui-input-details', UiInputDetails);
    app.component('ui-period-picker-input', UiPeriodPickerInput);
    app.component('ui-date-time-picker', UiDateTimePicker);
    app.component('ui-info', UiInfo);
    app.component('ui-checkbox', UiCheckbox);
    app.component('ui-radio', UiRadio);
    app.component('ui-radio-group', UiRadioGroup);
    app.component('ui-switcher', UiSwitcher);
    app.component('ui-textarea', UiTextarea);
    app.component('ui-icon', UiIcon);
    app.component('ui-plan-limits', UiPlanLimits);
    app.component('ui-treeview', UiTreeview);
    app.component('ui-update-info', UiUpdateInfo);
    app.component('ui-tabs', UiTabs);
    app.component('ui-copy-input', UiCopyInput);
    app.component('ui-copy-textarea', UiCopyTextarea);
    app.component('ui-count-input', UiCountInput);
    app.component('ui-create-url-tags', UiCreateUrlTags);
    app.component('ui-not-found', UiNotFound);
    app.component('ui-table', UiTable);
    app.component('ui-phone-input', UiPhoneInput);
  }
}

export default new UIService();
